/** Type-safe indexing function to work around TypeScript's limitations */
export function at<T>(arr: readonly T[], index: number): T | undefined {
    return arr[index];
}
